import type { ReactNode } from 'react';
import {
  Container,
  CoverContainer,
  CoverImage,
  Gradient,
  Content,
} from './styled';
import { Helmet } from 'react-helmet';

export interface Props {
  alt?: string;
  imageSource?: string;
  imageSourceSet?: string;
  width?: number;
  height?: number;
  children: ReactNode;
  className?: string;
}

export const ImageHeader = ({
  imageSource,
  imageSourceSet,
  alt = 'Header cover image',
  children,
  width,
  height,
  className,
}: Props) => {
  return (
    <Container className={className}>
      <CoverContainer>
        <Gradient />
        {typeof imageSource === 'string' && imageSource !== '' ? (
          <>
            <Helmet>
              <link
                rel="preload"
                as="image"
                href={imageSource}
                imageSrcSet={imageSourceSet}
                /* eslint-disable-next-line */
                // @ts-ignore - https://github.com/facebook/react/issues/25682
                fetchpriority="high"
              />
            </Helmet>
            <CoverImage
              data-cy-id="header-cover-image"
              src={imageSource}
              srcSet={imageSourceSet}
              alt={alt}
              width={width}
              height={height}
            />
          </>
        ) : null}
      </CoverContainer>
      {typeof children !== 'undefined' && <Content>{children}</Content>}
    </Container>
  );
};
